import { GridApi } from '@ag-grid-community/core';

export function deselectAllRows<T>(api: GridApi<T> | undefined) {
    api?.deselectAll();
}
